const URL_REG_EXP =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/g

const urlUtil = {
  isFullUrl: (url: string) => {
    return URL_REG_EXP.test(url)
  },
  getFullUrl: (url: string) => {
    return url.startsWith('http') ? url : url.replace(/(?!http)(.*)/, 'http://$1')
  },
}

export default urlUtil
